export function isCorrectUrl(link) {
    return /\.com$/i.test(link)
        || /^((http(s)?|ftp|file):\/\/)/i.test(link)
        || /^www\./i.test(link)
        || isStrictlyCorrectUrl(link);
}

/**
 * 判断是否为链接——严格模式
 * 规则: 1. 以 (http|https|ftp):// 开头
 *      2. 以 . 为分隔符，至少包含两个分隔符，前两段需要以英文字母[a-zA-Z]开头
 *      3. IP 地址
 * @param link
 * @returns {boolean}
 */
export function isStrictlyCorrectUrl(link) {
    // eslint-disable-next-line no-useless-escape
    const reg = /^((http(s)?|ftp):\/\/|([a-zA-Z][\w\-_]*\.))([a-zA-Z][\w\-_]*)(\.[\w\-_]+)+([\w-.,@?^=%&:/~\+#!()*]*[\w-@?^=%&/~\+#!()*])?$/g;
    const IPAddressReg = /^((http(s)?:\/\/)*((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2}))(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/i;

    return reg.test(link) || IPAddressReg.test(link);
}

export function isCorrectEmail(link) {
    // eslint-disable-next-line no-useless-escape
    const reg = /^([\w\-\.])+\@([\w\-\.])*([\w\-])\.([A-Za-z]{2,4})$/;
    return reg.test(link);
}
